import AnalyticsProfil from '../../../features/supervision/analytics/components/AnalyticsProfil/AnalyticsProfil';
import { PageTable, Header } from '/src/layouts/page';
import { useParams } from "react-router-dom";

function AnalyticsPage() {
    const params = useParams();
    return (
        <PageTable>

            <>
                <Header title={<span>{"Operational Dashboard"}</span>}></Header>
                <AnalyticsProfil />
            </>


        </PageTable>
    );
}

export default AnalyticsPage;